/* eslint-disable @eslint-community/eslint-comments/disable-enable-pair */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Image from 'next/image';
import SwiperCore, { Navigation, Keyboard } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Media from '../../../models/media';
import PDPModal from '../pdp-modal/PdpModal';
import styles from './pdp-image-modal.module.scss';

type Props = {
  closeModal: () => void;
  imageIndex: number;
  images: Media[] | undefined;
  isDesktop: boolean;
  isOpen: boolean;
};

const PDPImageModal = ({
  closeModal,
  imageIndex,
  images,
  isDesktop,
  isOpen
}: Props) => {
  if (!images) return <></>;

  SwiperCore.use([Navigation, Keyboard]);

  const DesktopModal = () => (
    <>
      <div className={styles['pdp-image-modal__swiper-container']}>
        <Swiper
          className={styles.swiper}
          navigation
          keyboard
          spaceBetween={0}
          slidesPerView={1}
          initialSlide={imageIndex}
        >
          {images?.map(({ alt, src }) => (
            <SwiperSlide
              className={styles['pdp-image-modal__slide-wrapper']}
              key={src}
            >
              <img
                alt={alt}
                src={src}
                className={styles['pdp-image-modal__slide']}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );

  const MobileModal = () => (
    <div className={styles['pdp-image-modal__mobile-image-container']}>
      <Image
        alt={images[imageIndex].alt}
        height={images[imageIndex].height}
        src={images[imageIndex].src}
        width={images[imageIndex].width}
      />
    </div>
  );

  return (
    <PDPModal darkTheme isModalOpen={isOpen} onCloseModal={closeModal}>
      {isDesktop ? <DesktopModal /> : <MobileModal />}
    </PDPModal>
  );
};

export default PDPImageModal;
